import { Navigate, useLocation } from 'react-router-dom'
import { useGetCurrentUserQuery } from '@/entities/user'
import { useGetClientCountQuery } from '../api/subscription'
import { Loader } from '@/shared/ui' // or any spinner/loading component you use

export const RequireSubscription = ({
	children
}: {
	children: JSX.Element
}) => {
	const {
		data: currentUser,
		isLoading: isUserLoading,
		isFetching: isUserFetching
	} = useGetCurrentUserQuery(undefined, { refetchOnMountOrArgChange: true })

	const {
		data: clientNumber,
		isLoading: isClientLoading,
		isFetching: isClientNumberFetching
	} = useGetClientCountQuery(
		{
			organizationId: currentUser?.organizationId
		},
		{ refetchOnMountOrArgChange: true }
	)

	const location = useLocation()

	// Guard logic
	const hasActiveSubscription = currentUser?.activeSubscription
	const hasReachedLimit =
		clientNumber?.currentClientNumber >= clientNumber?.maxClientNumber
	// ensures that the user does not get redirected when they skip free trial
	// so by adding this variable, after the user skips the free trial, they will not be redirected
	// and can continue adding clients
	const isOnFreeTrial = currentUser?.freeTrail === true

	if (
		isUserLoading ||
		isClientLoading ||
		isUserFetching ||
		isClientNumberFetching
	) {
		return <Loader />
	}

	if (hasActiveSubscription && hasReachedLimit && isOnFreeTrial) {
		return <Navigate to='/' state={{ from: location }} replace />
	}

	return children
}
